import { AgendaService } from 'src/app/services/agenda.service';
import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Agenda } from 'src/app/entities/agenda';
import { NgForm, FormGroupDirective, FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {UtilitiesService} from "src/app/services/utilities.service";


@Component({
  selector: 'app-add-agenda',
  templateUrl: './add-agenda.component.html',
  styleUrls: ['./add-agenda.component.css']
})
export class AddAgendaComponent implements OnInit {

    constructor(private agendaService: AgendaService,
                private  dialogRef: MatDialogRef<AddAgendaComponent>,
                private utilitiesService: UtilitiesService,
                @Inject(MAT_DIALOG_DATA) public data: AddAgendaComponent) { }

    agenda: Agenda = this.data.agenda;
    editMode: boolean = this.data.editMode;
    openSpaceId: number = this.data.openSpaceId;
    matcher = new MyErrorStateMatcher();
    description = new FormControl('');
    place = new FormControl('', [this.utilitiesService.noAllWhitespaceValidator]);
    startTime = new FormControl('', [Validators.required, ]);
    formGroup = new FormGroup({ description: this.description, place: this.place, startTime: this.startTime});

    ngOnInit(): void {
      if (this.agenda)
      {
        this.description.setValue(this.agenda.description);
        this.place.setValue(this.agenda.place);
        this.startTime.setValue(this.agenda.startTime);
      }
    }

    onSubmit(){
      this.matcher.submited = true;
      if (this.formGroup.invalid) {
        return;
      }

      if (this.agenda)
      {
        this.transformToAgenda();
        this.updateAgenda();
      }
      else {
        this.agenda = new Agenda();
        this.transformToAgenda();
        this.addAgenda();
      }
    }

  addAgenda() {
    this.agendaService.addAgenda(this.agenda)
      .subscribe(
        (_) => {
          this.onClose();
        },
        (error) => {
          console.error(error);
        }
      );
  }

  updateAgenda(){
    this.agendaService.updateAgenda(this.agenda.id, this.agenda)
    .subscribe(
      (_) => {
        this.onClose();
      },
      error => {
        console.error(error);
      }
    );
  }

  onClose() {
    this.dialogRef.close();
  }

  transformToAgenda(){
    this.agenda.description = this.formGroup.get('description').value;
    this.agenda.place = this.formGroup.get('place').value;
    this.agenda.startTime = this.formGroup.get('startTime').value;
    this.agenda.publicAgenda = false;
    this.agenda.openSpaceId = this.openSpaceId;
  }

}
export class MyErrorStateMatcher implements ErrorStateMatcher {
    submited = false;
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      const isSubmitted = this.submited;
      return !!(control && control.invalid && (isSubmitted));
  }
}


